
@if (dailyCustomRouteData?.startPoint) {
  <section class="custom-route__start-point">
    <ci-icon 
      class="start-point__icon"
      type="svg" 
      name="location-on"
    ></ci-icon>
    
    <div class="start-point__info">
      <h2 class="start-point__address ci-paragraph-p1-semibold">
        {{ dailyCustomRouteData.startPoint.address }}
      </h2>
      
      @if (getstartDateForStartPoint()) {
        <span class="start-point__time ci-caption-regular">
          {{ 'Salida a las'  | translate }} 
          {{ getstartDateForStartPoint() | date: 'HH:mm' }}
        </span>
      }
    </div>
  </section>
}